import { getPublicEnvironmentVariables } from '@module/mdrt-org/shared/utils/helpers/get-public-environment-variables';
import { getStringWithQueryParameters } from '@module/mdrt-org/shared/utils/helpers/get-string-with-query-parameters';
import { fetchWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/fetch-with-error-handling';

import { type GetCompanyPendingMembersRequest, type GetCompanyPendingMembersResult } from './types';

export const getCompanyPendingMembers = async (
  accessToken?: string,
  requestData?: GetCompanyPendingMembersRequest,
  signal?: AbortSignal
) => {
  const publicEnvironmentVariables =
    typeof window === 'undefined' ? await getPublicEnvironmentVariables() : window.PUBLIC_ENV;

  const { sortAscending, ...restRequestData } = requestData ?? {};

  const urlWithSearchParameters = getStringWithQueryParameters(
    `${publicEnvironmentVariables.apiBaseUrl}/${publicEnvironmentVariables.companyAdminRoute}/CompanyAdmin/CompanyListings/PendingMembers`,
    { ...restRequestData, sortAscending: sortAscending?.toString() }
  );

  if (!accessToken) {
    throw new Error('Access token is not available');
  }

  return await fetchWithErrorHandling<GetCompanyPendingMembersResult>(urlWithSearchParameters, {
    cache: 'no-store',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Ocp-Apim-Subscription-Key': publicEnvironmentVariables.ocpCompanyAdminSubscriptionKey ?? '',
    },
    signal,
  });
};
